export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0023_thumb.95332dc1.jpg";